module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_12.1389582f.jpg";